import React from 'react';
import { Button } from "@/components/ui/button";
import { Megaphone } from 'lucide-react';
import { useAdModal } from '@/context/AdModalContext';

interface AdPlaceholderProps {
  height?: string;
  width?: string;
  text?: string;
  className?: string;
}

const AdPlaceholder: React.FC<AdPlaceholderProps> = ({
  height = 'h-32',
  width = 'w-full',
  text = '',
  className = ''
}) => {
  const { openAdModal } = useAdModal();

  return (
    <div
      className={`relative border border-border rounded-lg ${height} ${width} my-8 ${className}`}
    >
      <Button
        variant="outline"
        onClick={openAdModal}
        className="absolute top-2 right-2 bg-secondary text-secondary-foreground border-border hover:bg-primary hover:text-primary-foreground z-10 text-xs px-2 py-1 h-auto"
      >
        <Megaphone size={12} className="mr-1" /> Reklámbevételek
      </Button>
    </div>
  );
};

export default AdPlaceholder;
